import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Mode } from '@/common/entityFramework/enumerations/Mode';

const gilGpSideNav = {
  id: 'gp',
  children: [
    {
      id: 'gpMnSapSoxRecon',
      displayName: 'SOX Reconciliation',
      icon: fas.faFileInvoiceDollar,
      role: 'GP_MN_SAP_SOX_RECON_VIEW',
      route: 'gp/mn-sap-sox-recon',
      state: { mode: Mode.PERSPECTIVE },
    },
    {
      id: 'gpMnSapComplRecon',
      displayName: 'Compliance Reconciliation',
      icon: fas.faFileInvoiceDollar,
      role: 'GP_MN_SAP_COMPL_RECON_VIEW',
      route: 'gp/mn-sap-compl-recon',
      state: { mode: Mode.PERSPECTIVE },
    },
  ],
};

export default gilGpSideNav;
